export const AlertIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="7.5" stroke="#E8344E" stroke-width="1.75" />
      <rect
        x="10.8333"
        y="7.29175"
        width="1.66667"
        height="1.66667"
        rx="0.833333"
        transform="rotate(-180 10.8333 7.29175)"
        fill="#E8344E"
      />
      <path
        d="M10 13.5833L10 8.86658"
        stroke="#E8344E"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};
